'use strict';

module.exports = function compact(array) {
  if (!Array.isArray(array)) {
    return [];
  }

  return array.filter(Boolean);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/algoliasearch-helper/src/functions/compact.js
// module id = ELfV
// module chunks = 0